export const keyCodes = {
    Enter: 'Enter',
    Escape: 'Escape'
}